import { Link } from 'react-router';
import React from 'react';
import PropTypes from 'prop-types';
// import consumer from '../../assets/consumer-trusted-blakground.png';
import canstar from '../../assets/cns-msc-broadband-NZ-2019.png';
import './Footer.scss';

const Footer = props =>
  <footer className="footer">
    <div className="footer-content">

      <ul className="footer-navigation">
        <li className="footer-navigation-item">
          <a
            className="footer-navigation-item-link autotest-footer-navigation-item-about"
            href="https://www.skinny.co.nz/about/"
            target="_blank"
            rel="noopener noreferrer"
          >
            About
          </a>
        </li>
        <li className="footer-navigation-item">
          <a
            className="footer-navigation-item-link autotest-footer-navigation-item-skinny-terms"
            href="https://www.skinny.co.nz/skinny-terms/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Skinny Terms & Conditions
          </a>
        </li>
        <li className="footer-navigation-item">
          <Link
            className="footer-navigation-item-link autotest-footer-navigation-item-contacts"
            to="/contact-us"
            target="_blank"
          >
            Contact
          </Link>
        </li>
        <li className="footer-navigation-item">
          <a
            className="footer-navigation-item-link autotest-footer-navigation-item-complaints"
            href="https://www.skinny.co.nz/help/make-a-complaint/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Got an issue?
          </a>
        </li>
        <li className="footer-navigation-item">
          <a
            className="footer-navigation-item-link autotest-footer-navigation-item-privacy-policy"
            href="https://www.skinny.co.nz/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </li>
      </ul>

      <ul className="footer-social">
        <li className="footer-social-item">
          <a
            className="footer-social-item-link autotest-footer-social-item-facebook"
            href="https://www.facebook.com/skinny"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="footer-facebook-logo" />
            <span className="sr-only">
              Skinny Facebook
            </span>
          </a>
        </li>
        <li className="footer-social-item">
          <a
            className="footer-social-item-link autotest-footer-social-item-youtube"
            href="http://www.youtube.com/user/skinnymobile"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="footer-youtube-logo" />
            <span className="sr-only">
              Skinny YouTube
            </span>
          </a>
        </li>
      </ul>

      <div className="footer-help autotest-footer-help">
        <div className="footer-paragraph">
          <p className="footer-help-text">
            Need a hand? It&apos;s OK we&apos;re here to
            <a
              href="https://www.skinny.co.nz/help/unlimited-broadband1"
              className="footer-help-link"
              target="_blank"
              rel="noopener noreferrer"
            >
            Help
          </a>
          </p>
          <div className="footer-awards">
            {/* <img src={consumer} alt={'Consumer Trusted'} /> */}
            {props.showCanstar &&
            <img src={canstar} alt="Canstar Award" />
            }
          </div>
        </div>
        <p className="footer-paragraph footer-help-copyright">
          © Skinny 2025 all rights reserved
        </p>
      </div>

    </div>
  </footer>
;

Footer.propTypes = {
  showCanstar: PropTypes.bool
};

Footer.defaultProps = {
  showCanstar: false
};

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Footer/Footer.js
 **/